let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eiW2i")).then(() => parcelRequire('hal1Q'));